import Analytics from '@getaccept/lib-shared/src/analytics';
import { AnalyticsEvent, AnalyticsUserTrait } from '@getaccept/lib-shared/src/types/analytics';
import { countries } from '@getaccept/lib-shared/src/countries/constants/countries';
import type { CreateEntityFormData, MqlData } from '../types/create-entity-form-data';
import type { ErrorMessage } from '../../common/types/error-message';
import { SignupErrorKey } from '../../common/enums/signup-error-key';
import { useGoogleTagManager } from '../../common/composables/google-tag-manager.composable';
import { t } from '../../common/helpers/translation';

export function getErrorMessage(error: Error) {
  switch (error.message) {
    case SignupErrorKey.EntityAlreadyExists:
      return {
        title: t('entity-name-already-exists'),
        description: t('please-try-again-with-a-new-entity-name'),
      };
    case SignupErrorKey.EntityNameIsEmpty:
    default:
      return {
        title: t('something-went-wrong'),
        description: t('please-try-again-or-contact-support_v2'),
      };
  }
}

export async function trackSignupSuccess(
  isSignup: boolean,
  userId = '',
  formData: CreateEntityFormData,
  mqlData: MqlData
) {
  if (isSignup) {
    const analyticsData = {
      [AnalyticsUserTrait.Country]: formData.countryCode,
      [AnalyticsUserTrait.DataCenter]: formData.datacenter,
      [AnalyticsUserTrait.SignupStep]: 3,
    };
    Analytics.identify(userId, analyticsData);
    Analytics.track(AnalyticsEvent.SignupLoadedStep3, analyticsData);

    await useGoogleTagManager().createEntity({
      userId,
      companyName: formData.name,
      country:
        countries.find(({ key }) => key === formData.countryCode)?.label || formData.countryCode,
      ...mqlData,
    });
  } else {
    const analyticsData = { [AnalyticsUserTrait.SignupStep]: undefined };
    Analytics.track(AnalyticsEvent.SignupCompleted, analyticsData);
    Analytics.identify(undefined, analyticsData);
  }
}

export function trackSignupError(errorMessage: ErrorMessage | undefined) {
  if (!errorMessage) return;
  Analytics.track(AnalyticsEvent.SignupFailed, {
    errorMessage: errorMessage.title,
    [AnalyticsUserTrait.SignupStep]: 3,
  });
  Analytics.identify(undefined, {
    [AnalyticsUserTrait.SignupStep]: 3,
  });
}
